module.exports = {
      id: "personalise-usage",
      viewBox: "0 0 14.128 12.555",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#personalise",
      toString: function () {
        return this.url;
      }
    }